export default "__VITE_ASSET__CBzu2UMU__"